import { createContext, useContext } from "react";

export const DialogBodyContext = createContext<HTMLElement | null>(null);

/** The non-scrolling box around the dialog's scrolling body, for an overlay
 *  that fills the body whatever it is scrolled to. Null outside a dialog. */
export const useDialogBody = (): HTMLElement | null =>
  useContext(DialogBodyContext);
